// extracted by mini-css-extract-plugin
export var title = "index-module--title--21mNY";
export var project = "index-module--project--taCqn";
export var imageCount = "index-module--imageCount--20chs";